import ControlRoomBanner from './ControlRoomBanner';

export default ControlRoomBanner;
